export default __webpack_public_path__ + "static/media/regulation-on.d5cbb998.png";